// extracted by mini-css-extract-plugin
module.exports = {"comp":"ListB3_comp__usiY1"};